"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChip = void 0;
var core_1 = require("@material-ui/core");
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseChip = styled_components_1.default(core_1.Chip).withConfig({ displayName: "BaseChip", componentId: "sc-1541hm" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["color:", ";background-color:", ";border:solid 1px ", ";padding:0.5rem;text-transform:none;font-size:", ";font-weight:600;@media (hover: hover){&:hover{background:", ";}}"], ["", "", "", "", "", ""])), function (_a) {
    var theme = _a.theme, $variant = _a.$variant, $color = _a.$color;
    return theme.vui.component.chip.variant[$variant][$color].color;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant, $color = _a.$color;
    return theme.vui.component.chip.variant[$variant][$color].backgroundColor;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant, $color = _a.$color;
    return theme.vui.component.chip.variant[$variant][$color].border;
}, polished_1.rem(13), function (_a) {
    var theme = _a.theme, $variant = _a.$variant, $color = _a.$color;
    return theme.vui.component.chip.variant[$variant][$color].hoverBgColor;
});
var templateObject_1;
